import React, { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import FormDataContext from "integrations/contexts/FormDataContext";
import { OnePassword } from "@graylog/enterprise-api";
import { renderOptions } from "../common/Options";
import FormWrap from "../common/FormWrap";
import ValidatedInput from "../common/ValidatedInput";
import formValidation from "../common/utils/formValidation";
const StepAuthorize = ({ onSubmit, onChange }) => {
  const { t } = useTranslation("enterprise_integrations");
  const { formData } = useContext(FormDataContext);
  const [formError, setFormError] = useState(null);
  const { endPoint } = formData;
  const subscriptions = [
    { label: "1Password Business", value: "https://events.1password.com/" },
    { label: "1Password Enterprise", value: "https://events.ent.1password.com/" },
    { label: "1Password EU", value: "https://events.1password.eu/" },
    { label: "1Password CA", value: "https://events.1password.ca/" }
  ];
  const handleSubmit = () => {
    var _a, _b;
    const fetcher = OnePassword.checkCredentials({
      api_token: ((_a = formData == null ? void 0 : formData.apiToken) == null ? void 0 : _a.value) || "",
      end_point: ((_b = formData == null ? void 0 : formData.endPoint) == null ? void 0 : _b.value) || ""
    });
    fetcher.then((result) => {
      if (result.result === "valid") {
        setFormError(null);
        onSubmit();
      } else {
        setFormError({
          full_message: result.result,
          nice_message: t("onepassword.authorize.connection_error")
        });
      }
    }).catch((err) => {
      setFormError({
        full_message: err.message,
        nice_message: t("onepassword.authorize.connection_error")
      });
    });
  };
  const isFormValid = formValidation.isFormValid(["onePasswordName", "apiToken", "endPoint"], formData);
  return /* @__PURE__ */ React.createElement(
    FormWrap,
    {
      onSubmit: handleSubmit,
      className: "col-md-7",
      buttonContent: t("common.buttons.verify_connection_and_proceed"),
      disabled: isFormValid,
      title: "",
      error: formError,
      description: ""
    },
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "onePasswordName",
        type: "text",
        fieldData: formData.onePasswordName,
        onChange,
        placeholder: t("common.fields.input_name"),
        label: t("common.fields.input_name"),
        autoComplete: "off",
        help: t("common.fields.input_name_help"),
        defaultValue: endPoint == null ? void 0 : endPoint.value,
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        className: "",
        id: "apiToken",
        type: "password",
        fieldData: formData.apiToken,
        onChange,
        label: t("onepassword.authorize.api_token"),
        help: t("onepassword.authorize.api_token_help"),
        autoComplete: "off",
        required: true
      }
    ),
    /* @__PURE__ */ React.createElement(
      ValidatedInput,
      {
        type: "select",
        id: "endPoint",
        onChange,
        fieldData: formData.endPoint,
        help: t("onepassword.authorize.account_type_help"),
        required: true,
        label: t("onepassword.authorize.account_type")
      },
      renderOptions(subscriptions, t("onepassword.authorize.choose_account_type"), false)
    )
  );
};
export default StepAuthorize;
